import { useEffect, useRef, useState } from 'react'
import { Tooltip } from 'antd'

const DEFAULT_HIDE_AFTER_MS = 2000

/**
 * Tooltip that auto-hides after `hideAfterMs` while the pointer stays hovered.
 */
const AutoHideTooltip = ({
    title,
    children,
    hideAfterMs = DEFAULT_HIDE_AFTER_MS,
    ...tooltipProps
}) => {
    const [open, setOpen] = useState(false)
    const hideTimerRef = useRef(null)

    const clearHideTimer = () => {
        if (hideTimerRef.current) {
            window.clearTimeout(hideTimerRef.current)
            hideTimerRef.current = null
        }
    }

    useEffect(() => () => clearHideTimer(), [])

    const handleOpenChange = (nextOpen) => {
        clearHideTimer()

        if (!title) {
            setOpen(false)
            return
        }

        setOpen(nextOpen)

        if (nextOpen) {
            hideTimerRef.current = window.setTimeout(() => {
                setOpen(false)
                hideTimerRef.current = null
            }, hideAfterMs)
        }
    }

    return (
        <Tooltip
            {...tooltipProps}
            title={title}
            open={open}
            onOpenChange={handleOpenChange}
        >
            {children}
        </Tooltip>
    )
}

export default AutoHideTooltip
